module.exports = "/_next/static/images/77c678dbdf67a68f8f55ea60412c8d41-man-sitting-with-notebook@md-2x.jpg.webp";